import { render, staticRenderFns } from "./data37.vue?vue&type=template&id=60ce1f9d&scoped=true&"
import script from "./data37.vue?vue&type=script&lang=js&"
export * from "./data37.vue?vue&type=script&lang=js&"
import style1 from "./data37.vue?vue&type=style&index=1&id=60ce1f9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ce1f9d",
  null
  
)

export default component.exports